module.exports = __webpack_public_path__ + "img/papua-logo.e6d617aa.png";